export const environment = {
  production: true,
  client_id: '30267b0d-252e-4702-a368-d480c337b369',
  app_url: 'https://acc.chem-entitlement.xom.cloud/',
  base_api_url: 'https://ext.apiproxyuat.exxonmobil.com/sccot-sc-entitlement-api/v1',
  base_api_scope: 'api://chem-entitlement-api-acc/access_as_user',
  base_api_swagger:
    'https://ext.apiproxyuat.exxonmobil.com/sccot-sc-entitlement-api/v1/swagger/v1/swagger.json',
};
